import React from "react";
import { useTranslation } from "react-i18next";
import s from "./style.module.scss";

const ProgressBar = (props) => {
  const { t } = useTranslation("surveyTaker");
  const { currentTheme } = props;
  let percentCompleted = Math.round(
    (props.completedQuestions / props.totalQuestions) * 100
  );

  return (
    <div className={s.progressBarContainer}>
      <div
        className={s.progressBarOutline}
        style={{ backgroundColor: "#fffffff" }}
      >
        <div
          className={s.progressBarFilled}
          style={{
            width: percentCompleted + "%",
            backgroundColor: currentTheme.primaryColor,
          }}
        ></div>
      </div>
      {props.showPercentage && (
        <div className={s.progressTextContainer}>
          <p className={s.progressText}>
            <b>{percentCompleted}%</b> {t("surveyTaker:completed")}
          </p>
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
